import PropTypes from 'prop-types'
import USBModal from '@usb-shield/react-modal'
import DigitalService from './digitalservice/index'
import './findBills.scss'

const DisclaimerModal = ({
  isOpenDisclaimerModal,
  handleClick,
  disclaimer,
  displayName = ''
}) => (
  <USBModal
    isOpen={isOpenDisclaimerModal}
    backdrop="static"
    toggle={() => null}
    wrapID="disclaimer-modal"
    data-test="modal-component"
    handleModalClose={() => {
      handleClick()
    }}
    footerButtonOptions={[
      {
        type: 'primary',
        id: 'close-primary',
        text: 'Close',
        clickEvent: () => {
          handleClick()
        }
      }
    ]}
    modalTitle={<article>{displayName} Terms of use</article>}
  >
    <DigitalService digitalContent={disclaimer} />
  </USBModal>
)

DisclaimerModal.propTypes = {
  isOpenDisclaimerModal: PropTypes.bool,
  handleClick: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  disclaimer: PropTypes.objectOf(PropTypes.any),
  displayName: PropTypes.string
}

DisclaimerModal.defaultProps = {
  isOpenDisclaimerModal: false,
  handleClick: () => null,
  disclaimer: {},
  displayName: null
}
export default DisclaimerModal
